var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepaymentRecordIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1894_701)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09832 1.90123C3.86121 1.7005 3.64116 1.48044 3.44043 1.24333L2.92727 0.736763C2.63122 0.513079 2.92727 0.697291 2.57859 0.532817L1.06543 6.23675C1.20359 6.23675 6.37464 4.92096 6.7957 4.61175L5.61148 3.42096C6.64802 2.72698 7.83425 2.28851 9.07295 2.14146C10.3117 1.9944 11.5676 2.14296 12.7378 2.57497C13.908 3.00697 14.9592 3.71012 15.8052 4.62679C16.6512 5.54346 17.268 6.64757 17.6049 7.8486C17.9639 9.11346 17.9946 10.4489 17.6942 11.729C17.3938 13.009 16.7721 14.1913 15.8878 15.1644C13.651 17.6381 11.901 17.7104 8.94043 17.8683V19.9473C16.7891 20.342 21.4931 13.4539 19.5852 7.11176C17.2694 -0.559288 8.2628 -1.56587 4.11149 1.88808L4.09832 1.90123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.487305 13.0198L1.03994 14.5198L2.95441 13.5988C2.86128 13.1696 2.67236 12.767 2.40178 12.4211L0.487305 13.0198Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4873 18.9474L6.99388 19.5067L7.57283 17.5461L6.46099 17.0396L5.4873 18.9474Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40137 16.4144C2.67785 16.8386 3.02239 17.2142 3.42111 17.5263C3.92575 17.0473 4.388 16.5257 4.80269 15.9671L4.00663 15.092L2.40137 16.4144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00657895 10.8093L2.07237 10.6185L2.11184 9.42115L0 9.30273L0.00657895 10.8093Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49388 6.23015C8.00057 6.17128 7.50304 6.15589 7.00704 6.18412C7.0335 6.78302 7.02032 7.383 6.96757 7.98016L6.69125 8.01963H6.3623V9.33542H6.98073V10.7039H6.37547V12.0196H6.99388V13.7433H8.3952V12.0262H10.4018L11.4478 13.7367H12.9741V12.0394H13.5926V10.7236H12.9347V9.37489H13.5531V8.0591H12.9478V6.24333H11.5334V8.04595H9.5202L8.49388 6.23015ZM11.3031 10.6907C10.9534 10.2765 10.6552 9.82139 10.4149 9.33542H11.5663V10.6907H11.3031ZM8.3952 9.32227H8.71757L9.54651 10.6775H8.3952V9.32227Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1894_701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.9671,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepaymentRecordIcon);
export default __webpack_public_path__ + "static/media/repayment_record_icon.942a62e767b2854530e10a645e827600.svg";
export { ForwardRef as ReactComponent };